import { FC } from 'react';
import { Route } from '../../constants/Route';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import { Icon } from '../Icon';
import { Link } from '../Link.client';

interface QuickLinkItem {
  title: string;
  route: Route;
  icon: string;
}

const QuickLinkItems: QuickLinkItem[] = [
  {
    title: 'ペット\n仏具',
    route: { route: 'category', handle: 'ペット仏具' },
    icon: 'Guide',
  },
  {
    title: 'ご利用\nガイド',
    route: { route: 'guides' },
    icon: 'Guide2',
  },
  {
    title: 'よくある\n質問',
    route: { route: 'questions' },
    icon: 'FAQ2',
  },
  {
    title: 'ペット\n位牌',
    route: { route: 'category', handle: 'ペット位牌' },
    icon: 'PhotoGoods',
  },
];

export const QuickLink: FC = () => {
  const isDesktop = useIsDesktop();

  return (
    <section className="bg-dark">
      <div className="flex flex-wrap items-center justify-center gap-8 py-8">
        <div className={isDesktop ? '' : 'w-full text-center'}>
          <h2 className="font-outfit text-2xl text-white">QUICK LINK</h2>
          <p className="text-sm text-white">よく見られているページ</p>
        </div>
        {QuickLinkItems.map((item, i) => (
          <QuickLinkCard {...item} key={i} />
        ))}
      </div>
    </section>
  );
};

const QuickLinkCard: FC<QuickLinkItem> = ({ title, route, icon }) => (
  <div className="w-32 rounded-md bg-white py-4">
    <Link {...route} className="flex flex-col items-center justify-center">
      <Icon name={icon} className="h-6 w-6 fill-black" />
      <p className="mt-2 whitespace-pre-wrap text-center text-sm font-semibold">{title}</p>
    </Link>
  </div>
);
